export const ADD_TO_ODDS_SELECTIONS = "ADD_TO_ODDS_SELECTIONS";
export const ADD_TO_FILTER_SELECTIONS = "ADD_TO_FILTER_SELECTIONS";
export const REMOVE_FROM_FILTER_SELECTIONS = "REMOVE_FROM_FILTER_SELECTIONS";

export const SET_PP_CONFIG_DATA = "SET_PP_CONFIG_DATA";
export const SET_ACTIVE_FILTER_VIEW = "SET_ACTIVE_FILTER_VIEW";
export const SET_ACTIVE_VIEW = "SET_ACTIVE_VIEW";
export const SET_WARNING = "SET_WARNING";
export const SELECT_FAVOURITE = "SELECT_FAVOURITE";
